import type { QueryClient } from '@tanstack/react-query';

let _client: QueryClient | null = null;

export function setSharedQueryClient(client: QueryClient): void {
  _client = client;
}

export function getSharedQueryClient(): QueryClient | null {
  return _client;
}
